import { benefitsContent } from '@/mocks/content';

export default function BenefitsSection() {
  return (
    <section className="py-14 md:py-20 bg-secondary-50">
      <div className="px-4 md:px-6 lg:px-10 max-w-[1280px] mx-auto">
        <div className="mb-10 md:mb-14">
          <p className="text-xs font-semibold text-foreground-400 uppercase tracking-[0.15em] mb-3">
            {benefitsContent.subtitle}
          </p>
          <h2 className="text-3xl md:text-5xl font-heading font-bold text-foreground-950 leading-[1.12]">
            Perché utilizzare
            <br />
            <span className="font-normal italic">Itaobuy Spreadsheet?</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {benefitsContent.benefits.map((benefit) => (
            <div
              key={benefit.id}
              className="group rounded-xl p-6 md:p-7 bg-background-50/80 transition-all duration-300 hover:bg-background-50"
            >
              <div className="w-11 h-11 rounded-lg bg-accent-100 flex items-center justify-center mb-5 transition-colors duration-300 group-hover:bg-accent-200">
                <i className={`${benefit.icon} text-xl text-accent-600`}></i>
              </div>
              <h3 className="text-lg font-heading font-semibold text-foreground-900 mb-3">
                {benefit.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {benefit.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}